/**
 * FIXME: When upgrading to node 10, latest Intl specs. add an additional space between currency symbol and amount. This happens in node 10+, latest
 * chrome, and firefox. Safari doesn't seem to effected.
 * UX doesn't like the extra space so we need to strip the extra space. `sanitizedCurrencySymbol` is implemented in
 * 5.x of node-hacommons-i18n but PDP is on 3.x. When I (@tnguyen2) attempted to upgrade to 5.x the module wasn't consumeable client-side
 * in production build (couldn't figure out why) and the module doesn't build an esm for tree shaking so PDP would take on an additional 7+ KB
 * without tree shaking.
 *
 * Intl specs: http://cldr.unicode.org/translation/number-patterns
 */

/**
 * * Return sanitized locale with dash between language, country and variation
 */
const sanitizedCurrencySymbol = (currency) => currency.replace(/\s(?=\d)/, '');

export default sanitizedCurrencySymbol;
